import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://githubcom/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://githubcom/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  // for all options read: https://wwwi18nextcom/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "en",
    preload: ["en", "fr"],
    ns: ["translation"],
    defaultNS: "translation",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      customHeaders: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      crossDomain: true,
      //withCredentials: true,
      //requestOptions: { credentials: "include" },
      //loadPath: "./locales/{{lng}}/translation.json",
      loadPath:
        "https://" +
        window.location.hostname +
        "/525series/locales/{{lng}}/{{ns}}.json",
    },
    detection: {
      order: ["navigator"],
    },
  });

export default i18n;
